export default __webpack_public_path__ + "static/483-f60846038a0fe03fa41b820d67ea6cf2.gif";